import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import styles from '../styles/pages/TermsAndConditions.module.css';
import DefaultPage from './DefaultPage';

const TermsAndConditions: React.FC<RouteComponentProps> = () => {
  return (
    <DefaultPage header={{ title: 'TERMS AND CONDITIONS' }}>
      <div className={styles.termsContainer}>
        <p className={styles.text}>
          This <b>ACCESS</b>EXPRESS Subscription Agreement is made by and
          between EVERSANA Life Science Services, LLC (“EVERSANA”) and the user
          (“<u>Customer”</u>) at the time of purchase (“<u>Effective Date</u>”).
          This <b>ACCESS</b>EXPRESS Subscription Agreement consists of the
          restrictions of use and the Terms and Conditions below and
          incorporated herein by reference (collectively this “Agreement”). Each
          party has read, understands and agrees to the terms and conditions of
          this Agreement.
        </p>
        <ul>
          <li>
            By subscribing to EVERSANA’s <b>ACCESS</b>EXPRESS service, Customer
            will be able to submit customized survey questions to a group of
            respondents selected by Customer in accordance with this Agreement
            (the “Survey Subscription”); provided, however, that Customer shall
            not include any survey questions that collect Personal Identifiable
            Information. Respondents will provide responses to Customer’s survey
            questions in accordance with this Agreement (“Responses”). This
            Agreement will be in writing, signed by an authorized representative
            of each party. “Personally Identifiable Information” or “PII” means
            information and metadata that, alone or in combination, is linked or
            linkable to a specific respondent so as to allow a reasonable person
            who does not have personal knowledge of the relevant circumstances,
            to identify the respondent with reasonable certainty. Personally
            identifiable information includes but is not limited to: (a) the
            respondent’s name; (b) the name of the respondent’s spouse or other
            family members; (c) the address or phone number of the respondent or
            respondent’s family; (d) personal identifiers such as the
            respondent’s state-assigned identifier, social security number,
            AMA#, NPI#, or biometric record; (e) indirect identifiers such as
            the respondent’s date of birth, place of birth or mother’s maiden
            name; and (f) demographic attributes, such as race, socioeconomic
            information, and gender.
          </li>
          <li>
            Fees. A service fee will be due and payable by credit card using
            EVERSANA’s online portal at the time a survey is ordered by
            Customer. Said fees are non-refundable.
            <br />
            <br />
            WARRANTIES/DISCLAIMERS. EVERSANA HEREBY EXPRESSLY DISCLAIMS ANY
            WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, WITH RESPECT TO THE
            SURVEY SUBSCRIPTION AND THE RESPONSES, INCLUDING, WITHOUT LIMITATION
            ANY WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
            NON-INFRINGEMENT. SPECIFICALLY, EVERSANA DOES NOT WARRANT THAT THE
            SURVEY SUBSCRIPTION OR THE RESPONSE WILL MEET CUSTOMER’S
            REQUIREMENTS AND/OR EXPECTATIONS.
          </li>
          <li>
            LIMITATION OF LIABILITY. IN NO EVENT WILL A PARTY BE LIABLE TO THE
            OTHER PARTY FOR ANY INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL
            DAMAGES, INCLUDING LOSS OF PROFITS, REVENUES, DATA, USE, INCURRED BY
            THE OTHER PARTY ARISING OUT OF OR RELATED TO THIS AGREEMENT, UNDER
            ANY THEORY OF LIABILITY, WHETHER IN AN ACTION IN CONTRACT, STRICT
            LIABILITY, TORT (INCLUDING GROSS NEGLIGENCE) OR OTHER LEGAL OR
            EQUITABLE THEORY, EVEN IF SUCH PARTY KNEW OR SHOULD HAVE KNOWN OF
            THE POSSIBILITY OF SUCH DAMAGES. THE TOTAL LIABILITY OF EVERSANA
            UNDER THIS AGREEMENT, FOR ALL CLAIMS IN THE AGGREGATE, UNDER ANY
            THEORY OF LIABILITY, WHETHER IN AN ACTION IN CONTRACT, STRICT
            LIABILITY, TORT (INCLUDING GROSS NEGLIGENCE) OR OTHER LEGAL OR
            EQUITABLE THEORY, WILL NOT IN ANY EVENT EXCEED THE TOTAL AMOUNT PAID
            BY CUSTOMER TO EVERSANA DURING THE 12-MONTH PERIOD PRIOR TO THE
            CLAIM THAT GIVES RISE TO SUCH LIABILITY.
          </li>
          <li>
            Respective Rights of the Parties. Customer will have sole ownership
            of and all right and title to the Responses. EVERSANA will have sole
            ownership of and all right and title to the Survey Subscription.
          </li>
          <li>
            Sub-contracting. In the event that Provider contracts with a
            subcontractor any of its obligations hereunder, Provider shall (i)
            remain liable for the performance of such obligations and will be
            responsible for the acts and omissions of its subcontractors, (ii)
            require its permitted subcontractors to agree to be bound by the
            obligations of this Agreement, and (iii) remain Company’s sole point
            of contact regarding the Services provided hereunder (including any
            deliverables), including with respect to payment.
          </li>
          <li>
            Term. The term of this Agreement shall be from the Effective Date
            until terminated as set forth below. Termination or expiration of
            this Agreement or any renewal or extension thereof shall not operate
            to terminate the obligations under Sections 3, 4, 9, 10, 11, 12, 13,
            15, 18, or 19 hereof or other obligations which survive in
            accordance with applicable law, which shall survive the expiration
            or termination of this Agreement.
          </li>
          <li>
            Termination.
            <ul>
              <li>
                Each party reserves the right at any time, upon giving at least
                ninety (90) day’s prior written notice to the other party, to
                terminate this Agreement.
              </li>
              <li>
                In the event of any material breach of this Agreement, the
                non-breaching party may terminate this Agreement by giving ten
                (10) business days prior written notice to the other party;
                provided, however, that this Agreement will not terminate if the
                other party has cured the breach before the expiration of such
                ten (10) business day period.
              </li>
              <li>
                This Agreement is terminable immediately without notice by a
                party if the other party; (i) voluntarily institutes insolvency,
                receivership or bankruptcy proceedings; (ii) is involuntarily
                made subject to any bankruptcy or insolvency proceeding and such
                proceeding is not dismissed within sixty (60) days of the filing
                of such proceeding; (iii) makes an assignment for the benefit of
                creditors; or (iv) undergoes any dissolution or cessation of
                business.
              </li>
            </ul>
          </li>
          <li>
            Non-Assignment. Neither EVERSANA nor Customer shall assign this
            Agreement or any of their rights and obligations under this
            Agreement to another party without the prior written consent of the
            other party. This Agreement will inure for the benefit of and be
            binding upon EVERSANA and Customer and their respective successors
            and permitted assigns including, without limitation, any entity that
            shall acquire Customer or EVERSANA.
          </li>
          <li>
            Publicity. Each party agrees not to originate or use the name of the
            other party or any of its employees or affiliates, in any publicity,
            news release or other public announcement, written or oral, whether
            to the public, press or otherwise, relating to this Agreement, to
            any amendment hereto, or to the performance hereunder, without the
            prior written consent of the other party.
          </li>
          <li>
            Governing Law. This Agreement, and any and all disputes arising from
            or relating to this Agreement, shall be governed by and construed in
            accordance with the laws of the State of New York without regard to
            any conflicts of law’s provisions.
          </li>
          <li>
            Independent Contractor. EVERSANA understands and agrees that
            EVERSANA’s relationship to Customer hereunder will be as an
            independent contractor and not an employee or agent of Customer, and
            EVERSANA will not be entitled to participate in any of the benefits
            and privileges available to Customer employees.
          </li>
          <li>
            Severability. If any provision of this Agreement is held invalid or
            unenforceable by a court of competent jurisdiction, the remaining
            provisions of this Agreement will remain in full force and effect,
            and the provision affected will be construed so as to be enforceable
            to the maximum extent permissible by law.
          </li>
          <li>
            Agreement Modifications. No modification of this Agreement shall be
            effective unless it is in writing and signed by an authorized
            representative of each party.
          </li>
          <li>
            Force Majeure. Neither party shall be deemed in default in the
            performance of its obligations under this Agreement to the extent
            such performance is temporarily prevented or delayed because of war,
            hostilities, riots, acts of terrorism, civil commotion, epidemic,
            earthquake, accident, fire, wind, flood, strike or comparable labor
            shutdowns outside of the reasonable control of the party, or any
            other act of God; provided that prompt notice of such Force Majeure
            shall be given by such party to the other party followed within a
            reasonable time by written confirmation. In such event, the noticing
            party shall be temporarily relieved of its obligations during the
            period of such event to the extent such event prevents its
            performance. If the Force Majeure event continues for one or more
            related periods of at least sixty (60) days, the other party shall
            have the unilateral right to terminate this Agreement by fourteen
            (14) days written notice.
          </li>
          <li>
            Non-Solicitation. During the Term of this Agreement and for a period
            of twelve (12) months thereafter, Customer shall not, directly or
            indirectly, in any manner solicit or induce for employment, or hire
            or engage the services of, any employee of EVERSANA or its
            Affiliates who performed any work under this Agreement. A general
            advertisement or notice of a job listing or opening or other similar
            general publication of a job search or availability to fill
            employment positions, including on the internet, shall not be
            construed as a solicitation or inducement for the purposes of this
            provision so long as the circumstances indicate that the same was
            not targeted or directed at EVERSANA employees.
            <br />
            If Customer breaches this provision, Customer shall pay to EVERSANA
            a sum equal to one year’s base salary that was payable by EVERSANA
            to that employee, plus the recruitment costs incurred by Provider in
            replacing such individual.
          </li>
          <li>
            Notices. All notices and other communications that may be or are
            required to be given hereunder shall be in writing and shall be
            deemed to have been duly given on the date of delivery if personally
            delivered; five days after mailing if mailed, first class postage
            prepaid; or one day after mailing if sent by independent overnight
            courier, and shall be addressed as follows:
            <br />
            <br />
            If to EVERSANA:
            <br />
            [Provider business contact]
            <br />
            [Address]
            <br />
            [City, State, ZIP]
            <br />
            <br />
            With a copy to:
            <br />
            General Counsel
            <br />
            EVERSANA Life Science Services, LLC
            <br />
            190 N. Milwaukee Street
            <br />
            Milwaukee, WI 53202
            <br />
            <br />
            If to Customer:
            <br />
            Either party may change its address for purposes of notice pursuant
            to this Agreement by notifying the other party of such change of
            address in the manner set forth above, except that notices for
            changes of address are effective only upon receipt by the other
            party
          </li>
          <li>
            Counterparts. This Agreement may be signed by the parties in
            separate counterparts, which shall together constitute one and the
            same agreement. Facsimile signatures shall have the same effect as
            originals.
          </li>
          <li>
            Dispute Resolution. If any dispute between the parties arises out of
            or relates to this Agreement, or the breach thereof, the parties
            agree to the following non-binding alternative dispute resolution
            procedures in lieu of litigation:
            <br />
            <ul>
              <li>
                Within five (5) business days of receipt by one party of a
                written claim or notice of dispute by the other party, the
                parties shall commence good faith negotiations to settle the
                dispute.
              </li>
              <li>
                If the dispute cannot be settled through negotiation after
                thirty (30) days, any remaining controversy or claim shall be
                settled and determined by arbitration administered by the
                American Arbitration Association under its Commercial
                Arbitration Rules. A single arbitrator shall conduct all
                arbitration proceedings in New York. Subject to reimbursement
                under the arbitrator’s final decision as outlined below, the
                parties shall share equally all costs charged by the American
                Arbitration Association and its agents, representatives,
                employees or independent contractors.
              </li>
              <li>
                The arbitrator also shall determine which is the prevailing
                party and shall include in the award or relief the reasonable
                attorney&apos;s fees and costs of such prevailing party in the
                arbitration. The arbitrator shall make his or her decision based
                upon the applicable legal principles and upon the evidence
                presented by the parties, and at the request of any party prior
                to conclusion of the hearing, shall provide a written reasoned
                decision which shall include findings of fact and conclusions of
                law supporting the decision.
              </li>
            </ul>
          </li>
          <li>
            Records and Audits. Each party shall keep full, complete and
            accurate records in connection with the Survey Subscription and use
            of the Responses hereunder for such periods as are required to
            comply with applicable laws.
          </li>
          <li>
            Entire Agreement. This Agreement contains the entire understanding
            between the parties and supersedes and cancels any and all prior
            agreements, written or oral, between them regarding the within
            subject matter. There are no representations, agreements,
            arrangements or understandings, oral or written, between or among
            the parties hereto relating to the subject matter of this Agreement
            that are not fully expressed herein.
          </li>
        </ul>
      </div>
    </DefaultPage>
  );
};

export default withRouter(TermsAndConditions);
